import { ResourceType } from '@/utils/constants'

// The notes vs bookmarks segment of an item's detail path, so a bookmark→note
// neighbor navigates to the right route. Uploaded files live under bookmarks.
export const itemDetailSegment = resourceType => (resourceType === ResourceType.NOTE ? 'notes' : 'bookmarks')

// Builds the detail-page path for an item across the three route families:
//   public:      /u/:username/collections/:collectionId/{notes|bookmarks}/:itemId
//   collection:  /collections/:collectionId/{notes|bookmarks}/:itemId
//   standalone:  /{notes|bookmarks}/:itemId
export function buildItemDetailPath({ username, collectionId, isCollectionItem, resourceType, itemId }) {
  const segment = itemDetailSegment(resourceType)

  if (username) return `/u/${username}/collections/${collectionId}/${segment}/${itemId}`
  if (isCollectionItem) return `/collections/${collectionId}/${segment}/${itemId}`
  return `/${segment}/${itemId}`
}
